<template>
    <div v-if="error"
        style="display: flex; flex-direction: column; justify-content: center; align-items: center; margin-top:10rem;">
        <img src="/assets/myinvois/images/Error Page Image.png" alt="Logo" style="width: 40rem; margin: 1rem;" />
        <div class="error-box">
            <p style="margin-bottom: 0;">Invalid session link.<br>If you have any concern, please contact us at <span
                    style="font-weight:bold;"><a :href="`mailto:${support_email_address}`">{{ support_email_address
                        }}</a></span>
            </p>
        </div>
    </div>
    <div v-else>
        <div class="header-container">
            <img :src="logo_file_path" alt="Logo" style="width: 9rem; margin: 1rem;" />
            <h4>Complete Details for <br class="mobile-next"> E-Invoicing Compliances
            </h4>
        </div>
        <div class="form-container">
            <div style="background-color: #e4e4e4;" class="rounded" v-if="is_submitted">
                <div style="display: flex; justify-content: center; margin-top: 20px;">
                    <svg  width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" fill="#008000"/>
                        <path d="M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z" fill="#ffffff"/>
                    </svg>
                </div>
                <p style="text-align: center; font-size: 14px; font-weight: bold; justify-content: center; margin: 8px;">
                    Congratulations! Your E-Invoice Info has been successfully submitted.
                </p>
            </div>
            <p></p>
            <form @submit.prevent="submit_form">

                <div style="font-size: 18px; font-weight: bold; color:black; padding: 1rem 0 0 0;">
                    <span v-if="claim_as === 'Company'">COMPANY DETAILS</span>
                    <span v-else>INDIVIDUAL DETAILS</span>
                </div>
                <hr class="title-line">

                <!-- NRIC and Name fields for Individual -->
                <div v-if="claim_as === 'Individual'" class="form-group">
                    <label for="identification_number_type" style="margin-bottom: 1rem;">
                        Identification Number Type
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <div class="identification-number-row">
                        <div v-for="identification_number_type in identification_number_type_options"
                            :key="identification_number_type" class="form-check">
                            <input type="radio" :id="identification_number_type"
                                v-model="formData.identification_number_type" :value="identification_number_type"
                                required :disabled="is_submitted" />
                            <label :for="identification_number_type" v-text="identification_number_type"
                                style="margin: 0 1rem 0 0;">
                            </label>
                        </div>
                    </div>
                </div>

                <div v-if="claim_as === 'Individual'" class="form-group">
                    <input type="text" pattern="[0-9]*" v-model="formData.identification_number"
                        id="identification_number" :placeholder="get_identification_number_placeholder" required
                        @keydown="handleKeydown" @input="handleInput" :disabled="is_submitted" />
                    <div class="form-error-msg">
                        <span v-if="form_error_data.identification_number">{{
                            form_error_data.identification_number }}</span>
                    </div>

                </div>

                <div class="form-group">
                    <label for="full_name">
                        <span v-if="claim_as === 'Company'">Company Name</span>
                        <span v-else>Full Name (as per ID)</span>
                        <span class="mandatory-label">&nbsp;*</span>
                    </label> <input type="text" v-model="formData.full_name" :disabled="is_submitted" />
                </div>

                <!-- Business Email or Email Field -->
                <div class="form-group">
                    <label for="email">
                        <span v-text="claim_as === 'Company' ? 'Company Email Address' : 'Email Address'"></span>
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input type="email" v-model="formData.email" id="email-field"
                        :placeholder="claim_as === 'Company' ? 'company@domain.com' : 'email@domain.com'"
                        :disabled="is_submitted" />
                    <div class="form-error-msg">
                        <span v-if="form_error_data.email">{{ form_error_data.email }}</span>
                    </div>
                </div>

                <div class="form-group">
                    <label for="contact_number">
                        <span v-text="claim_as === 'Company' ? 'Company Contact No.' : 'Contact No.'"></span>
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input id="phone" type="tel" :disabled="is_submitted" />
                    <div class="form-error-msg">
                        <span v-if="form_error_data.phone">{{ form_error_data.phone }}</span>
                    </div>
                </div>

                <div class="form-group">
                    <label for="tax_id">
                        <span
                            v-text="claim_as === 'Company' ? 'Company Tax Identification No. (TIN)' : 'Tax Identification No. (TIN)'"></span>
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input id="tax_id" type="text" v-model="formData.tax_id" placeholder="Eg: CXX53644000" required
                        :disabled="is_submitted"   @input="formData.tax_id = formData.tax_id.toUpperCase()" />
                    <div class="form-error-msg">
                        <span v-if="form_error_data.tax_id">{{ form_error_data.tax_id }}</span>
                    </div>
                </div>

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="roc">
                        New Business Registration No. (ROC)
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input id="roc" type="text" v-model="formData.roc" placeholder="Eg: 198301031144" required
                        :disabled="is_submitted" @input="formData.roc = formData.roc.toUpperCase()" />
                    <div class="form-error-msg">
                        <span v-if="form_error_data.roc">{{ form_error_data.roc }}</span>
                    </div>
                </div>

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="sst_number">
                        Sales and Services Tax (SST) Registration No.
                        <span class="mandatory-label">&nbsp;(Optional)</span>
                    </label>
                    <input id="sst_number" type="text" v-model="formData.sst_number" placeholder="Eg: XXX8888888888XX"
                        :disabled="is_submitted" @input="formData.sst_number = formData.sst_number.toUpperCase()" />
                    <div class="form-error-msg">
                        <span v-if="form_error_data.sst_number">{{ form_error_data.sst_number }}</span>
                    </div>
                </div>

                <div v-if="claim_as === 'Company' && is_supplier" class="form-group">
                    <label for="msic_code">
                        MSIC Code
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <select v-model="formData.msic_code" required :disabled="is_submitted" id="msic-code-select-element">
                        <option v-for="msic_code, index in msic_options" :key="index" :value="msic_code.name">
                            {{ msic_code.name }} - {{ msic_code.description }}
                        </option>
                    </select>
                </div>

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="fax_number">
                        Fax No.
                        <span class="mandatory-label">&nbsp;(Optional)</span>
                    </label>
                    <input type="text" v-model="formData.fax_number" placeholder="Eg: 123-456-7890"
                        :disabled="is_submitted" />
                </div>

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="operating_from_time">
                        Operating From Time
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input type="time" v-model="formData.operating_from_time" required :disabled="is_submitted" />
                </div>

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="operating_to_time">
                        Operating To Time
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input type="time" v-model="formData.operating_to_time" required :disabled="is_submitted" />
                </div>

                <!-- Sales Representative Info Fields -->
                <div v-if="claim_as === 'Company'"
                    style="font-size: 18px; font-weight: bold; color:black; padding: 1rem 0 0 0;">
                    <span>Sales Representative Info</span>
                </div>
                <hr v-if="claim_as === 'Company'" class="title-line">

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="sales_representative">
                        Sales Representative Name
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input type="text" v-model="formData.sales_representative" placeholder="Eg: John Doe" required
                        :disabled="is_submitted" />
                </div>

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="sales_representative_email">
                        Sales Representative Email
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input type="text" v-model="formData.sales_representative_email" id="sales_representative_email"
                        placeholder="Eg: john.doe@example.com" required :disabled="is_submitted" />
                    <div class="form-error-msg">
                        <span v-if="form_error_data.sales_representative_email">{{
                            form_error_data.sales_representative_email }}</span>
                    </div>
                </div>

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="sales_representative_contact_number">
                        Sales Representative Contact No.
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input id="sales_representative_contact_number" type="tel" :disabled="is_submitted" />
                    <div class="form-error-msg">
                        <span v-if="form_error_data.sales_representative_contact_number">{{
                            form_error_data.sales_representative_contact_number }}</span>
                    </div>
                </div>

                <!-- Accounts Receivable Representative Info Fields -->
                <div v-if="claim_as === 'Company'"
                    style="font-size: 18px; font-weight: bold; color:black; padding: 1rem 0 0 0;">
                    <span>Accounts Receivable Representative Info</span>
                </div>
                <hr v-if="claim_as === 'Company'" class="title-line">

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="accounts_receivable_representative">
                        Accounts Receivable Representative Name
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input type="text" v-model="formData.accounts_receivable_representative" placeholder="Eg: Jane Doe"
                        required :disabled="is_submitted" />
                </div>

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="accounts_receivable_representative_email">
                        Accounts Receivable Representative Email
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input type="text" v-model="formData.accounts_receivable_representative_email"
                        id="accounts_receivable_representative_email" placeholder="Eg: jane.doe@example.com" required
                        :disabled="is_submitted" />
                    <div class="form-error-msg">
                        <span v-if="form_error_data.accounts_receivable_representative_email">{{
                            form_error_data.accounts_receivable_representative_email }}</span>
                    </div>
                </div>

                <div v-if="claim_as === 'Company'" class="form-group">
                    <label for="accounts_receivable_representative_contact_number">
                        Accounts Receivable Representative Contact No.
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input id="accounts_receivable_representative_contact_number" type="tel" :disabled="is_submitted" />
                    <div class="form-error-msg">
                        <span v-if="form_error_data.accounts_receivable_representative_contact_number">{{
                            form_error_data.accounts_receivable_representative_contact_number }}</span>
                    </div>
                </div>


                <!-- Address Fields -->
                <div style="font-size: 18px; font-weight: bold; color:black; padding: 1rem 0 0 0;">
                    <span v-text="claim_as === 'Company' ? 'COMPANY ADDRESS' : 'ADDRESS'"></span>
                </div>
                <hr class="title-line">

                <div class="form-group">
                    <label for="address_line_1">
                        <span>Address Line 1</span>
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input type="text" v-model="formData.address_line_1" placeholder="NO 123, Jalan Besar" required
                        :disabled="is_submitted" />
                </div>

                <div class="form-group">
                    <label for="address_line_2">
                        <span>Address Line 2</span>
                        <span class="mandatory-label">&nbsp;(Optional)</span>
                    </label>
                    <input type="text" v-model="formData.address_line_2"
                        :placeholder="is_submitted ? '' : 'Apartment 5A'" :disabled="is_submitted" />
                </div>

                <div class="form-group">
                    <label for="postcode">
                        <span>Postcode</span>
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input type="text" v-model="formData.postcode" placeholder="12345" required
                        :disabled="is_submitted" />
                </div>

                <div class="form-group">
                    <label for="country">
                        <span>Country</span>
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <select v-model="formData.country" required :disabled="is_submitted">
                        <option v-for="country in country_options" :key="country.name" :value="country.name">
                            {{ country.name }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="state">
                        <span>State</span>
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <select v-model="formData.state_code" required
                        :disabled="is_submitted || formData.country != 'Malaysia'">
                        <option v-for="state_code in filtered_state_options" :key="state_code.name"
                            :value="state_code.name">
                            {{ state_code.name }} - {{ state_code.state }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="city">
                        <span>City</span>
                        <span class="mandatory-label">&nbsp;*</span>
                    </label>
                    <input v-if="formData.country != 'Malaysia'" type="text" v-model="formData.city"
                        placeholder="Enter city" required :disabled="is_submitted" />
                    <select v-else-if="formData.state_code" v-model="formData.city" required :disabled="is_submitted">
                        <option v-for="(city, index) in set_cities(formData.state_code)" :key="index" :value="city">
                            {{ city }}
                        </option>
                    </select>
                    <select v-else>
                        <option disabled>Please Choose State First</option>
                    </select>
                </div>

                <div class="form-actions">
                    <button type="submit" class="btn-primary" :class="{ 'btn-success': is_submitted }"
                        :disabled="is_submitting || is_submitted" style="border-radius: 2rem; font-weight: bold;">
                        {{ is_submitted ? "Submitted" : (is_submitting ? "Submitting..." : "Submit") }}
                    </button>
                </div>
            </form>
            <div style="text-align: center; margin-top: 2rem; color: #398bff; font-size: 14px;">
                Powered by <a :href="`https://www.byondwave.com/`" target="_blank" style="color: #398bff;">BYONDWAVE.com</a>
            </div>
        </div>
    </div>
</template>

<script>
import { getCities } from "malaysia-postcodes";
import SlimSelect from 'slim-select'

export default {
    props: ["frm", "session_id"],
    data() {
        return {
            session_id: this.session_id,
            error: false,
            support_email_address: "",
            logo_file_path: "",
            formData: {
                doctype: '',
                name: '',
                full_name: '',
                email: '',
                contact_number: '',
                country_iso2: '',
                identification_number_type: 'MyKad',
                identification_number: '',
                tax_id: '',
                roc: '',
                sst_number: '',
                msic_code: '',
                fax_number: '',
                operating_from_time: '',
                operating_to_time: '',
                sales_representative: '',
                sales_representative_email: '',
                sales_representative_contact_number: '',
                sales_representative_country_iso2: '',
                accounts_receivable_representative: '',
                accounts_receivable_representative_email: '',
                accounts_receivable_representative_contact_number: '',
                accounts_receivable_representative_country_iso2: '',
                address_line_1: '',
                address_line_2: '',
                postcode: '',
                city: '',
                state_code: '',
                country: 'Malaysia',
                session_id: this.session_id,
            },
            state_options: [],
            country_options: [],
            msic_options: [],
            slim_select_instance: null,
            identification_number_type_options: [],
            is_submitting: false,
            is_submitted: false,
            is_supplier: false,
            claim_as: "",
            phone_instance: null,
            sales_representative_contact_number_instance: null,
            accounts_receivable_representative_contact_number_instance: null,
            form_error_data: {},
        };
    },
    computed: {
        filtered_state_options() {
            // Filter out "All State" and "Not Applicable"
            return this.state_options.filter(option =>
                // option.state !== 'All States' && option.state !== 'Not Applicable'
                option.name !== "00"
            )
        },
        get_identification_number_placeholder() {
            if (this.formData.identification_number_type === "MyKad") {
                return "Eg: 020712081223";
            } else if (this.formData.identification_number_type === "Passport") {
                return "Eg: A12345678";
            }
            return "Enter Identification Number";
        },
    },
    methods: {
        get_profile() {
            frappe.call({
                method: "myinvois.api.get_profile",
                args: {
                    session_id: this.session_id,
                },
                callback: (response) => {
                    if (response.success) {
                        const response_info = response.message.customer_einvoice_info[0];

                        this.identification_number_type_options = response.message.identification_number_type_options;
                        if (response_info.customer) {
                            this.formData.name = response_info.customer;
                            this.claim_as = response_info.customer_type;
                            this.formData.doctype = "Customer";
                        } else if (response_info.supplier) {
                            this.formData.name = response_info.supplier;
                            this.claim_as = response_info.supplier_type;
                            this.is_supplier = true;
                            this.formData.doctype = "Supplier";
                        }
                        this.logo_file_path = response.message.logo_file_path;

                        if (response_info.docstatus == 0) {
                            this.formData.full_name = response_info.full_name;

                            if (response_info.customer_type == "Company")
                                this.formData.identification_number_type = ""

                        } else if (response_info.docstatus == 1) {
                            if (response_info.customer_type === "Individual" || response_info.supplier_type === "Individual") {
                                this.formData.identification_number_type = response_info.identification_number_type;
                                this.formData.identification_number = response_info.identification_number;

                            } else if (response_info.customer_type === "Company" || response_info.supplier_type === "Company") {
                                this.formData.roc = response_info.business_registration_of_company_number_roc;
                                if (response_info.sales_and_services_tax_sst_registration_number == "") {
                                    this.formData.sst_number = " "
                                } else {
                                    this.formData.sst_number = response_info.sales_and_services_tax_sst_registration_number;
                                }
                                this.formData.msic_code = response_info.msic_code;
                                this.formData.fax_number = response_info.fax_number;
                                this.formData.operating_from_time = this.set_time_format(response_info.operating_from_time);
                                this.formData.operating_to_time = this.set_time_format(response_info.operating_to_time);

                                this.formData.sales_representative = response_info.sales_representative;
                                this.formData.sales_representative_email = response_info.sales_representative_email;
                                this.formData.sales_representative_contact_number = response_info.sales_representative_contact_number;
                                this.formData.accounts_receivable_representative = response_info.accounts_receivable_representative;
                                this.formData.accounts_receivable_representative_email = response_info.accounts_receivable_representative_email;
                                this.formData.accounts_receivable_representative_contact_number = response_info.accounts_receivable_representative_contact_number;

                                const sales_representative_contact_number_country = this.sales_representative_contact_number_instance.getSelectedCountryData(response_info.sales_representative_country_iso2);
                                const sales_representative_contact_number_dial_code = `+${sales_representative_contact_number_country.dialCode}`;
                                const sales_representative_contact_number = document.querySelector("#sales_representative_contact_number");
                                sales_representative_contact_number.value = response_info.sales_representative_contact_number.slice(sales_representative_contact_number_dial_code.length);

                                this.sales_representative_contact_number_instance.setCountry(response_info.sales_representative_country_iso2);

                                const accounts_receivable_representative_contact_number_country = this.accounts_receivable_representative_contact_number_instance.getSelectedCountryData(response_info.accounts_receivable_representative_country_iso2);
                                const accounts_receivable_representative_contact_number_dial_code = `+${accounts_receivable_representative_contact_number_country.dialCode}`;
                                const accounts_receivable_representative_contact_number = document.querySelector("#accounts_receivable_representative_contact_number");
                                accounts_receivable_representative_contact_number.value = response_info.accounts_receivable_representative_contact_number.slice(accounts_receivable_representative_contact_number_dial_code.length);

                                this.accounts_receivable_representative_contact_number_instance.setCountry(response_info.accounts_receivable_representative_country_iso2);
                            }
                            this.formData.full_name = response_info.full_name;
                            this.formData.email = response_info.email;
                            this.formData.contact_number = response_info.contact_number;

                            this.phone_instance.setCountry(response_info.country_iso2);

                            const country = this.phone_instance.getSelectedCountryData(response_info.country_iso2);
                            const dial_code = `+${country.dialCode}`;
                            const phone_input = document.querySelector("#phone");
                            phone_input.value = response_info.contact_number.slice(dial_code.length);

                            this.phone_instance.setCountry(response_info.country_iso2);

                            this.formData.tax_id = response_info.tax_id;
                            this.formData.address_line_1 = response_info.address_line_1;
                            this.formData.address_line_2 = response_info.address_line_2;
                            this.formData.postcode = response_info.postcode;
                            this.formData.city = response_info.city;
                            this.formData.state_code = response_info.state_code;

                            this.is_submitted = true;
                        }
                    } else {
                        this.error = true;
                        this.support_email_address = response.message.support_email_address;
                    }
                }
            });
        },
        set_time_format(time_string) {
            const [hours, minutes] = time_string.split(':').map((part) => parseInt(part, 10) || 0);

            // Pad hours and minutes to always have two digits
            const formatted_hours = hours.toString().padStart(2, '0');
            const formatted_minutes = minutes.toString().padStart(2, '0');

            return `${formatted_hours}:${formatted_minutes}`;
        },
        get_msic_codes() {
            frappe.call({
                method: "myinvois.api.get_msic_codes",
                args: {},
                callback: (response) => {
                    if (response.message) {
                        this.msic_options = response.message;
                        this.$nextTick(() => {
                            if (this.slim_select_instance) {
                                this.slim_select_instance.destroy();
                            }
                            this.slim_select_instance = new SlimSelect({
                                select: '#msic-code-select-element',
                            });
                        });
                    }
                }
            });
        },
        get_country_and_state_codes() {
            frappe.call({
                method: "myinvois.api.get_country_and_state_codes",
                args: {},
                callback: (response) => {
                    if (response.message) {
                        this.state_options = response.message.state_codes;
                        this.country_options = response.message.countries;
                    }
                }
            });
        },
        set_cities(state) {
            const matched_state = this.state_options.find(state_dict => state_dict.name === state)

            if (matched_state.state === 'Wilayah Persekutuan Kuala Lumpur')
                return ["Kuala Lumpur"]
            else if (matched_state.state === 'Wilayah Persekutuan Labuan')
                return ["Labuan"]
            else if (matched_state.state === 'Pulau Pinang')
                matched_state.state = "Penang";
            else if (matched_state.state === 'Wilayah Persekutuan Putrajaya')
                return ["Putrajaya"]
            return getCities(matched_state.state)
        },
        validate_form() {
            let isValid = true;
            this.form_error_data = {}; // Clear previous errors

            const form_container = document.querySelector(".form-container");
            const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            const nricPattern = /^\d{6}\d{2}\d{4}$/;
            const passportPattern = /^[AHKahk]\d{8}$/;
            const taxIDPatternIndividual = /^(IG)(\d{9,11})$/; // Individual TINs
            const taxIDPatternCompany = /^[CDEF](\d{9,11})(0?)$/;  // Non-Individual TINs

            const rocPattern = /^\d{4}(01|02|03|04|05|06)\d{6}$/;
            const sstRegNoPattern = /^[A-Z]\d{2}\d{4}\d{8}$/;

            const email_input = document.querySelector("#email-field");
            const sales_representative_email_input = document.querySelector("#sales_representative_email")
            const accounts_receivable_representative_email_input = document.querySelector("#accounts_receivable_representative_email")

            const phone_input = document.querySelector("#phone");
            const sales_representative_contact_number_input = document.querySelector("#sales_representative_contact_number");
            const accounts_receivable_representative_contact_number_input = document.querySelector("#accounts_receivable_representative_contact_number");

            const identification_number_input = document.querySelector("#identification_number");
            const tax_id_input = document.querySelector("#tax_id");
            const roc_input = document.querySelector("#roc");
            const sst_number_input = document.querySelector("#sst_number");

            const identification_number_patterns = {
                'MyKad': nricPattern,
                'Passport': passportPattern,
            };

            // if (!this.formData.tax_id || this.formData.tax_id === null || !taxIDPatternIndividual.test(this.formData.tax_id)) {
            //     this.form_error_data.tax_id = "Please enter a valid TIN.";
            //     isValid = false;
            //     tax_id_input.style.borderColor = "red";
            // } else {
            //     tax_id_input.style.borderColor = "";
            // }

            // Email Validation
            if (!this.formData.email || !emailPattern.test(this.formData.email)) {
                this.form_error_data.email = "Please enter a valid email address.";
                isValid = false;
                email_input.style.borderColor = "red";
            } else {
                email_input.style.borderColor = "";
            }

            // Phone Validation
            if (!this.phone_instance) {
                if (!phone_input.value) {
                    this.form_error_data.phone = "Please enter a phone number.";
                    isValid = false;
                    phone_input.style.borderColor = "red";
                } else {
                    phone_input.style.borderColor = "";
                }

            } else {
                const isValidPhone = this.phone_instance.isValidNumber();
                if (!isValidPhone) {
                    this.form_error_data.phone = "Please enter a valid phone number.";
                    isValid = false;
                    phone_input.style.borderColor = "red";
                } else {
                    phone_input.style.borderColor = "";
                }
            }

            if (this.claim_as == "Individual") {
                if (this.formData.identification_number_type) {
                    // Identification Number
                    if (identification_number_input) {
                        const value = this.formData.identification_number;
                        const pattern = identification_number_patterns[this.formData.identification_number_type];
                        if (!value || value === null || !pattern.test(value)) {
                            this.form_error_data.identification_number = `Please enter a valid ${this.formData.identification_number_type} number.`;
                            isValid = false;
                            identification_number_input.style.borderColor = "red";
                        } else {
                            identification_number_input.style.borderColor = "";
                        }
                    }
                }

                if (!taxIDPatternIndividual.test(this.formData.tax_id)) {
                    this.form_error_data.tax_id = "Please enter a valid TIN for an Individual.";
                    isValid = false;
                    tax_id_input.style.borderColor = "red";
                } else {
                    tax_id_input.style.borderColor = "";
                }

            } else if (this.claim_as == "Company") {
                if (!taxIDPatternCompany.test(this.formData.tax_id)) {
                    this.form_error_data.tax_id = "Please enter a valid TIN for a Company.";
                    isValid = false;
                    tax_id_input.style.borderColor = "red";
                } else {
                    tax_id_input.style.borderColor = "";
                }

                // Company ROC/BRN
                if (!this.formData.roc || this.formData.roc === null || !rocPattern.test(this.formData.roc)) {
                    this.form_error_data.roc = "Please enter a valid ROC.";
                    isValid = false;
                    roc_input.style.borderColor = "red";
                } else {
                    roc_input.style.borderColor = "";
                }

                // SST Registration No
                if (this.formData.sst_number != "" && !sstRegNoPattern.test(this.formData.sst_number)) {
                    this.form_error_data.sst_number = "Please enter a valid SST Registration No.";
                    isValid = false;
                    sst_number_input.style.borderColor = "red";
                } else {
                    sst_number_input.style.borderColor = "";
                }

                // Sales Representative Email Validation
                if (!this.formData.sales_representative_email || !emailPattern.test(this.formData.sales_representative_email)) {
                    this.form_error_data.sales_representative_email = "Please enter a valid email address.";
                    isValid = false;
                    sales_representative_email_input.style.borderColor = "red";
                } else {
                    sales_representative_email_input.style.borderColor = "";
                }

                // Sales Representative Contact Number Validation
                if (!this.sales_representative_contact_number_instance) {
                    if (!sales_representative_contact_number_input.value) {
                        this.form_error_data.sales_representative_contact_number = "Please enter a contact number.";
                        isValid = false;
                        sales_representative_contact_number_input.style.borderColor = "red";
                    } else {
                        sales_representative_contact_number_input.style.borderColor = "";
                    }
                } else {
                    const isValidSalesPhone = this.sales_representative_contact_number_instance.isValidNumber();
                    if (!isValidSalesPhone) {
                        this.form_error_data.sales_representative_contact_number = "Please enter a valid contact number.";
                        isValid = false;
                        sales_representative_contact_number_input.style.borderColor = "red";
                    } else {
                        sales_representative_contact_number_input.style.borderColor = "";
                    }
                }

                // Account Receivable Representative Email Validation
                if (!this.formData.accounts_receivable_representative_email || !emailPattern.test(this.formData.accounts_receivable_representative_email)) {
                    this.form_error_data.accounts_receivable_representative_email = "Please enter a valid email address.";
                    isValid = false;
                    accounts_receivable_representative_email_input.style.borderColor = "red";
                } else {
                    accounts_receivable_representative_email_input.style.borderColor = "";
                }

                // Account Receivable Representative Contact Number Validation
                if (!this.accounts_receivable_representative_contact_number_instance) {
                    if (!accounts_receivable_representative_contact_number_input.value) {
                        this.form_error_data.accounts_receivable_representative_contact_number = "Please enter an contact number.";
                        isValid = false;
                        accounts_receivable_representative_contact_number_input.style.borderColor = "red";
                    } else {
                        accounts_receivable_representative_contact_number_input.style.borderColor = "";
                    }
                } else {
                    const isValidAccountPhone = this.accounts_receivable_representative_contact_number_instance.isValidNumber();
                    if (!isValidAccountPhone) {
                        this.form_error_data.accounts_receivable_representative_contact_number = "Please enter a valid contact number.";
                        isValid = false;
                        accounts_receivable_representative_contact_number_input.style.borderColor = "red";
                    } else {
                        accounts_receivable_representative_contact_number_input.style.borderColor = "";
                    }
                }
            }
            if (!isValid) {
                form_container.style.border = "2px solid red";
            } else {
                form_container.style.border = ""
            }

            return isValid;
        },
        init_phone_input() {
            const phone_input = document.querySelector("#phone");
            const sales_representative_contact_number = document.querySelector("#sales_representative_contact_number");
            const accounts_receivable_representative_contact_number = document.querySelector("#accounts_receivable_representative_contact_number");

            if (phone_input) {
                this.phone_instance = intlTelInput(phone_input, {
                    initialCountry: "my",
                    loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js"),
                    separateDialCode: true,
                    useFullscreenPopup: false,
                    autoPlaceholder: "aggressive",
                    validationNumberTypes: ["FIXED_LINE_OR_MOBILE"]
                });

                phone_input.addEventListener("input", () => this.update_phone_number("phone"));
                phone_input.addEventListener("countrychange", () => this.update_phone_number("phone"));
            }

            if (sales_representative_contact_number) {
                this.sales_representative_contact_number_instance = intlTelInput(sales_representative_contact_number, {
                    initialCountry: "my",
                    loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js"),
                    separateDialCode: true,
                    useFullscreenPopup: false,
                    autoPlaceholder: "aggressive",
                    validationNumberTypes: ["FIXED_LINE_OR_MOBILE"]
                });
                sales_representative_contact_number.addEventListener("input", () => this.update_phone_number("sales_phone"));
                sales_representative_contact_number.addEventListener("countrychange", () => this.update_phone_number("sales_phone"));
            }

            if (accounts_receivable_representative_contact_number) {
                this.accounts_receivable_representative_contact_number_instance = intlTelInput(accounts_receivable_representative_contact_number, {
                    initialCountry: "my",
                    loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js"),
                    separateDialCode: true,
                    useFullscreenPopup: false,
                    autoPlaceholder: "aggressive",
                    validationNumberTypes: ["FIXED_LINE_OR_MOBILE"]
                });
                accounts_receivable_representative_contact_number.addEventListener("input", () => this.update_phone_number("account_phone"));
                accounts_receivable_representative_contact_number.addEventListener("countrychange", () => this.update_phone_number("account_phone"));
            }
        },
        update_phone_number(type) {
            if (type === "phone" && this.phone_instance) {
                const formatted_number = this.phone_instance.getNumber();
                const country_iso2 = this.phone_instance.getSelectedCountryData().iso2;
                const is_valid = this.phone_instance.isValidNumber();

                if (is_valid !== false) {
                    this.formData.contact_number = formatted_number;
                    this.formData.country_iso2 = country_iso2;
                }
            } else if (type === "sales_phone" && this.sales_representative_contact_number_instance) {
                const formatted_number = this.sales_representative_contact_number_instance.getNumber();
                const sales_representative_country_iso2 = this.sales_representative_contact_number_instance.getSelectedCountryData().iso2;
                const is_valid = this.sales_representative_contact_number_instance.isValidNumber();

                if (is_valid !== false) {
                    this.formData.sales_representative_contact_number = formatted_number;
                    this.formData.sales_representative_country_iso2 = sales_representative_country_iso2;
                }
            } else if (type === "account_phone" && this.accounts_receivable_representative_contact_number_instance) {
                const formatted_number = this.accounts_receivable_representative_contact_number_instance.getNumber();
                const accounts_receivable_representative_country_iso2 = this.accounts_receivable_representative_contact_number_instance.getSelectedCountryData().iso2;
                const is_valid = this.accounts_receivable_representative_contact_number_instance.isValidNumber();

                if (is_valid !== false) {
                    this.formData.accounts_receivable_representative_contact_number = formatted_number;
                    this.formData.accounts_receivable_representative_country_iso2 = accounts_receivable_representative_country_iso2;
                }
            }
        },
        submit_form() {
            if (this.is_submitting || this.is_submitted)
                return;

            const isValid = this.validate_form();
            if (!isValid)
                return;

            this.update_phone_number();

            this.is_submitting = true;
            frappe.call({
                method: "myinvois.api.submit_profile",
                args: { formData: this.formData },
                callback: (response) => {
                    this.is_submitting = false;

                    if (response.success) {
                        this.is_submitted = true;
                        frappe.show_alert({
                            title: "Success",
                            indicator: "green",
                            message: "Data submitted successfully.",
                        });
                    } else {
                        frappe.msgprint({
                            title: "Invalid",
                            indicator: "red",
                            message: response.message,
                        });
                    }
                },
                error: () => {
                    this.is_submitting = false;
                },
            });
        },
        handleKeydown(event) {
            const allowedKeyCodes = [
                48, 49, 50, 51, 52, 53, 54, 55, 56, 57, // Regular digits (0-9)
                96, 97, 98, 99, 100, 101, 102, 103, 104, 105, // Numpad digits (0-9)
                13, // Enter key
                8, // Backspace key
                9, // Tab key
                37, // Left arrow key
                39, // Right arrow key
                46, // Delete key
                65, // Ctrl+A
                88, // Ctrl+X
                67, // Ctrl+C
                86 // Ctrl+V
            ];

            if (event.type === 'keydown') {
                if (
                    allowedKeyCodes.includes(event.keyCode) ||
                    (event.ctrlKey && ["a", "x", "c", "v"].includes(event.key))
                ) {
                    return true;
                } else {
                    event.preventDefault();
                    return false;
                }
            }
        },
        handleInput(event) {
            const inputValue = event.target.value;
            const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
            this.formData.identification_number = sanitizedValue;

            event.target.value = sanitizedValue;
        },
    },
    watch: {
        'formData.identification_number_type'(new_value, old_value) {
            if (new_value !== old_value) {
                this.formData.identification_number = '';
            }
        },
        "formData.country"(new_country) {
            if (new_country !== "Malaysia") {
                this.formData.state_code = "17";
                this.formData.city = null;
            } else {
                this.formData.state_code = null;
                this.formData.city = null;
            }
        },
        claim_as(newValue) {
            if (newValue === "Company") {
                this.$nextTick(() => {
                    this.init_phone_input();
                    this.get_profile();
                });
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.get_profile();
            this.init_phone_input();
            this.get_msic_codes();
            this.get_country_and_state_codes();
        });
    },
    beforeUnmount() {
        if (this.phone_instance) {
            this.phone_instance.destroy();
        }
        if (this.sales_representative_contact_number_instance) {
            this.sales_representative_contact_number_instance.destroy();
        }
        if (this.accounts_receivable_representative_contact_number_instance) {
            this.accounts_receivable_representative_contact_number_instance.destroy();
        }
    }
};
</script>

<style scoped>
.header-container {
    text-align: center;
    background-color: #3663e6;
    padding: 20px;
    max-width: 500px;
    margin: 3rem auto 0 auto;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
}

h4 {
    color: white;
    margin-top: 1.2rem;
    margin-bottom: 0.5rem;
    font-weight: bold;
}

.form-container {
    background: white;
    padding: 20px 50px;
    max-width: 500px;
    margin: 0rem auto 3rem auto;
    display: flex;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
}

.form-group {
    margin-bottom: 20px;
}

label {
    font-weight: 600;
    display: block;
    margin-bottom: 8px;
    color: #555;
}

input {
    border-radius: 10px !important;
}

input,
select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 10px;
    font-size: 14px;
    transition: border-color 0.2s ease;
    background-color: white;
    color: black;
}

input:focus,
select:focus {
    border-color: #007bff;
    outline: none;
}

input[type=radio] {
    padding: 0;
    border: none;
}

.form-actions {
    text-align: center;
}

.btn-primary {
    background-color: #007bff;
    border: none;
    color: white;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.btn-primary:hover {
    background-color: #0056b3;
}

.example-text {
    color: #93999c;
    margin-bottom: 5px;
    font-size: 14px;
}

.mobile-next {
    display: none;
}

.error-box {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    border-radius: 5px;
    margin: 0 2rem;
    padding: 20px;
    font-size: 16px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mandatory-label {
    color: red;
}

.search-input {
    margin-bottom: 10px;
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
}

.btn-success {
    background-color: #28a745;
    color: white;
    border-color: #28a745;
}

.identification-number-row {
    display: flex;
    align-items: center;
}

.form-check {
    padding: 0;
    display: flex;
    align-items: center;
}

.title-line {
    border-width: 2px;
    margin-top: 0.8rem;
    background: black;
}

.form-error-msg {
    margin-top: 0.3rem;
    padding-left: 0.2rem;
    color: red;
    font-size: 14px;
}

@media (max-width: 575.99px) {
    .header-container {
        margin: 1rem 2rem 0 2rem;
    }

    .form-container {
        font-size: 0.875rem;
        margin: 0rem 2rem 1rem 2rem;
        padding: 20px;
    }

    .mobile-next {
        display: block;
    }

    h4 {
        font-size: 1.5rem;
    }
}
</style>